import * as core from '../../../../../../../core'

import { query } from './value-of-change-bar-chart.query'

export const RESOURCE = {
  payload: {
    alias: 'value.of.change.bar.chart',
    description: 'Bar chart of change impacts by value of change',
    name: 'Value of Change Bar Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
